const reviews = [
  {
    name: 'Robert T.',
    location: 'Tampa, FL',
    rating: 5,
    title: 'Finally found the hard-to-find part!',
    text: 'Searched everywhere for a replacement carrier stem for my 15-year-old verticals. Big box stores had nothing. Blinds USA had exactly what I needed, shipped in 2 days. Blinds are like new.',
    product: 'Vertical Blind Carrier Stem',
    date: 'Feb 2026',
  },
  {
    name: 'Maria S.',
    location: 'Chicago, IL',
    rating: 5,
    title: 'Property manager — use them for all 12 units',
    text: 'I manage a 12-unit building and go through a lot of blind parts. Blinds USA is my go-to. Great pricing on bulk cords, brackets, and slats. Reliable shipping every time.',
    product: 'Mini Blind Lift Cords (bulk)',
    date: 'Jan 2026',
    featured: true,
  },
  {
    name: 'James K.',
    location: 'Phoenix, AZ',
    rating: 5,
    title: 'Called the team — got exactly the right part',
    text: 'Wasn\'t sure which bracket fit my headrail. Called the support line and the guy helped me identify it in 2 minutes. Perfect fit when it arrived. Amazing customer service.',
    product: 'Inside Mount Bracket Set',
    date: 'Mar 2026',
  },
  {
    name: 'Linda P.',
    location: 'Denver, CO',
    rating: 4,
    title: 'Great selection, fast delivery',
    text: 'Was impressed by the sheer number of parts available. Found replacement tilt wands that matched my old ones perfectly. Will be a repeat customer for sure.',
    product: 'Blind Tilt Wand 28"',
    date: 'Feb 2026',
  },
  {
    name: 'David M.',
    location: 'Atlanta, GA',
    rating: 5,
    title: 'Saved me $400 vs. replacing the whole blind',
    text: 'Installer quoted me $400 to replace damaged verticals. Ordered replacement slats and carriers for $18. 20 minutes of my time and they look brand new. Incredible value.',
    product: 'Vertical Blind Slats + Carriers',
    date: 'Jan 2026',
  },
  {
    name: 'Sandra H.',
    location: 'Houston, TX',
    rating: 5,
    title: 'Great experience from start to finish',
    text: 'Easy to navigate website, clear descriptions, and fast checkout. Parts arrived well-packaged. The bead chain loop fit perfectly on my roller shade — works flawlessly.',
    product: 'Chain Bead Loop 48"',
    date: 'Mar 2026',
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((s) => (
        <i key={s} className={`text-sm ${s <= count ? 'ri-star-fill text-amber-500' : 'ri-star-line text-stone-300'}`} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-stone-50 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-block text-amber-600 text-xs font-bold tracking-widest uppercase mb-3">
              Customer Reviews
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-stone-900">What Our Customers Say</h2>
          </div>
          <div className="flex items-center gap-4 bg-white rounded-lg border border-stone-200 px-6 py-4">
            <div className="text-center">
              <div className="text-stone-900 font-bold text-3xl leading-none">4.9</div>
              <div className="flex justify-center mt-1">
                <Stars count={5} />
              </div>
              <div className="text-stone-400 text-xs mt-1">50,000+ orders</div>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div
              key={r.name}
              className={`rounded-lg p-6 border ${
                r.featured
                  ? 'bg-stone-900 border-stone-700'
                  : 'bg-white border-stone-200'
              }`}
            >
              <div className="flex items-start justify-between gap-3 mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full font-bold text-sm flex-shrink-0 ${
                    r.featured ? 'bg-amber-600 text-white' : 'bg-stone-100 text-stone-700'
                  }`}>
                    {r.name.charAt(0)}
                  </div>
                  <div>
                    <div className={`font-bold text-sm ${r.featured ? 'text-white' : 'text-stone-900'}`}>{r.name}</div>
                    <div className={`text-xs ${r.featured ? 'text-stone-400' : 'text-stone-400'}`}>{r.location}</div>
                  </div>
                </div>
                <span className={`text-xs ${r.featured ? 'text-stone-500' : 'text-stone-300'}`}>{r.date}</span>
              </div>
              <Stars count={r.rating} />
              <h4 className={`font-bold text-sm mt-3 mb-2 ${r.featured ? 'text-amber-400' : 'text-stone-800'}`}>
                {r.title}
              </h4>
              <p className={`text-sm leading-relaxed ${r.featured ? 'text-stone-300' : 'text-stone-600'}`}>{r.text}</p>
              <div className={`mt-4 pt-4 border-t text-xs font-medium ${
                r.featured ? 'border-stone-700 text-amber-500' : 'border-stone-100 text-amber-700'
              }`}>
                <i className="ri-shopping-bag-line mr-1.5" />
                {r.product}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
